<template>
  <div class="data-analysis">
    <LableContent label="匹配查询设置" hasCollapse showFullScreen>
      <SearchSetting class="tab-btn" ref="searchSetting" />
    </LableContent>
    <LableContent label="匹配单项工程" hasCollapse showFullScreen>
      <MatchProject
        class="tab-btn"
        ref="matchProjectRef"
        :getParams="getParams"
        @row-select="handleRowSelectCenter"
      />
    </LableContent>
    <LableContent label="匹配造价明细" hasCollapse showFullScreen>
      <MatchCostDetail
        class="tab-btn"
        ref="matchCostDetailRef"
        :getHistoryData="getHistoryData"
      />
    </LableContent>
  </div>
</template>

<script>
import LableContent from '@/components/LableContent/index.vue'
import SearchSetting from './SearchSetting.vue'
import MatchProject from './MatchProject.vue'
import MatchCostDetail from './MatchCostDetail.vue'

export default {
  name: 'DataAnalysis',
  components: { LableContent, SearchSetting, MatchProject, MatchCostDetail },
  data() {
    return {
      // 页面数据
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    getParams() {
      return this.$refs.searchSetting.getData()
    },
    getHistoryData() {
      return this.$refs.matchProjectRef.tableData
    },
    handleRowSelectCenter(row) {
      this.$refs.matchCostDetailRef.getData(row)
    }
  }
}
</script>

<style scoped>
.data-analysis {
}
</style>
